import './AboutUsSection.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useEffect } from 'react';

const AboutUsSection = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id='about'
      className="about-us-section d-flex align-items-center"
      style={{ backgroundImage: "url('/assets/about.png')" }}
    >
      <div className="container d-flex flex-column flex-md-row ">
        <div className="vertical-label d-none d-md-block">
          <span>About Us</span>
          <div className="vertical-line"></div>
        </div>

        <div className="about-us-content" data-aos="fade-right" data-aos-duration="2000">
          <div className="content-wrapper">
            <div className='horizontal-label d-md-none'>
          <div className="horizontal-line"></div>

            <h1 className='fontgeorgio'><span>About Us</span></h1>
          <hr/>
            
            </div>
            <h1 className="about-title">
              Effortless Travel,<br />
              Unmatched Comfort,<br />
              Every Mile
            </h1>
            <p className="about-desc mt-3">
              At JP Travel Lines, we redefine travel to limitless destinations with seamless, reliable, and luxurious transportation solutions. Whether it’s corporate travel, airport transfers, or personalized journeys, we ensure every ride is smooth, safe, and tailored to your needs. Our commitment to punctuality and excellence guarantees a hassle-free experience, no matter where you're headed.
            </p>
            <p className="about-desc mt-3">
              From business professionals to leisure travelers, we cater to every journey with top-notch service and modern fleet options. Trust JP Travel Lines to elevate your travel experience with comfort, efficiency, and unparalleled reliability.
            </p>
            <button className="btn btn-outline-dark mt-4 px-4 py-2">READ MORE</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
